module.exports = __webpack_public_path__ + "static/17-972056a9888869ab35ca29f3510f1b9c.jpg";